import { LayoutType } from '@sbercloud/uikit-product-utils';

export function getIframeSize(layoutType: LayoutType): {
  width: string;
  height: string;
} {
  switch (layoutType) {
    case 'mobile':
      return { width: '328', height: '226' };

    case 'tablet':
      return { width: '704', height: '484' };

    case 'desktop':
    case 'desktopSmall':
    default:
      return { width: '592', height: '407' };
  }
}
